var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_38",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H0.5V20H18.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.126 1.39453C10.126 1.16247 10.0339 0.939907 9.86977 0.775813C9.70567 0.611718 9.48311 0.519531 9.25105 0.519531C9.01898 0.519531 8.79642 0.611718 8.63233 0.775813C8.46824 0.939907 8.37605 1.16247 8.37605 1.39453V8.39453C8.37605 8.62659 8.46824 8.84915 8.63233 9.01325C8.79642 9.17734 9.01898 9.26953 9.25105 9.26953C9.48311 9.26953 9.70567 9.17734 9.86977 9.01325C10.0339 8.84915 10.126 8.62659 10.126 8.39453V1.39453ZM13.6179 3.14453C13.5182 3.08519 13.4077 3.04627 13.2929 3.03001C13.178 3.01376 13.0611 3.02051 12.9489 3.04987C12.8366 3.07922 12.7314 3.1306 12.6392 3.20101C12.547 3.27142 12.4697 3.35946 12.4119 3.46C12.354 3.56055 12.3167 3.67159 12.3022 3.78668C12.2876 3.90176 12.2961 4.01859 12.3272 4.13036C12.3582 4.24214 12.4111 4.34663 12.4829 4.43776C12.5546 4.52889 12.6438 4.60484 12.7452 4.6612C14.081 5.43005 15.1256 6.61826 15.7171 8.04146C16.3086 9.46466 16.4139 11.0433 16.0166 12.5324C15.6193 14.0216 14.7417 15.338 13.5198 16.2774C12.298 17.2168 10.8003 17.7267 9.25903 17.728C7.7178 17.7292 6.21923 17.2218 4.99583 16.2845C3.77242 15.3471 2.89257 14.0322 2.49279 12.5437C2.09301 11.0552 2.19564 9.47643 2.78477 8.05225C3.3739 6.62806 4.41658 5.43811 5.75105 4.66703C5.85064 4.60958 5.93793 4.53307 6.00795 4.44188C6.07797 4.35069 6.12934 4.2466 6.15913 4.13556C6.18892 4.02452 6.19655 3.90869 6.18158 3.7947C6.16661 3.68071 6.12934 3.57078 6.07188 3.4712C6.01443 3.37161 5.93792 3.28432 5.84673 3.2143C5.75554 3.14428 5.65146 3.09291 5.54041 3.06312C5.42937 3.03332 5.31355 3.02569 5.19955 3.04066C5.08556 3.05563 4.97564 3.09291 4.87605 3.15036C3.20745 4.11342 1.90335 5.60026 1.16607 7.38018C0.428794 9.1601 0.29957 11.1336 0.798449 12.9945C1.29733 14.8553 2.39642 16.4995 3.92518 17.6719C5.45395 18.8444 7.32693 19.4795 9.2535 19.4787C11.1801 19.4779 13.0525 18.8413 14.5804 17.6677C16.1082 16.494 17.206 14.849 17.7034 12.9877C18.2008 11.1264 18.0699 9.15304 17.3312 7.37371C16.5925 5.59438 15.2872 4.10858 13.6179 3.14686V3.14453Z",
    fill: "#CE9944"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.47d4a4b5752346c629263bdfe4c99413.svg";
export { ForwardRef as ReactComponent };